'use strict';

import { CoreRepository } from '../CoreRepository';
import { AutomationSchedule } from '../../Entities/Automation/AutomationSchedule';
import { AutomationScheduleCollection } from '../../Collections/Automation/AutomationScheduleCollection';

export class AutomationScheduleRepository extends CoreRepository {
  public getAutomationSchedules(userId: number, options = {}) {
    return this.webAPI.getAutomationSchedules(userId, options).then((response) => {
      const collection = new AutomationScheduleCollection();

      response.data.forEach((collectionItemData) => {
        const collectionItem = new AutomationSchedule();
        collectionItem.hydrate(collectionItemData);

        collection.addItem(collectionItem);
      });

      collection.setOffset(response.offset);
      collection.setLimit(response.limit);
      collection.setTotal(response.total);

      return collection;
    });
  }

  public updateAutomationSchedule(userId: number, automationScheduleId: number, options: any[]) {
    return this.webAPI
      .updateAutomationSchedule(userId, automationScheduleId, options)
      .then((response) => {
        const collectionItem = new AutomationSchedule();
        collectionItem.hydrate(response);

        return response;
      });
  }

  public createAutomationSchedule(userId: number, payload: any[]) {
    return this.webAPI.createAutomationSchedule(userId, payload).then((response) => {
      return response;
    });
  }

  public deleteAutomationSchedule(userId: number, automationScheduleId: number) {
    return this.webAPI.deleteAutomationSchedule(userId, automationScheduleId).then((response) => {
      return response;
    });
  }
}
